/** @format */
import { MutableRefObject, ReactNode, useState } from 'react';
import { createPortal } from 'react-dom';

import {
    isBrowser,
    useIsomorphicLayoutEffect,
} from '@toucan/client/global/nextjs';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface UsePortalEvent {
    portalRef: MutableRefObject<HTMLDivElement | null>;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
interface UsePortalArgs {
    bindTo: HTMLElement | null;
    onOpen?: () => void;
    onClose?: () => void;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    initiallyOpen?: boolean;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
interface PortalWrapperArgs {
    children: ReactNode;
}

/**
 * @deprecated use Feather/hooks/use-portal instead
 *
 * React hook for Portals
 */
export const usePortal = ({
    bindTo,
    onOpen,
    onClose,
    initiallyOpen = false,
}: UsePortalArgs) => {
    const [isOpen, setIsOpen] = useState<boolean>(initiallyOpen);

    const isTargetValid = isBrowser() && bindTo instanceof HTMLElement;
    const isPortalReadyAndOpen = isOpen && isTargetValid;

    const PortalWrapper = ({ children }: PortalWrapperArgs) => {
        if (isPortalReadyAndOpen && bindTo) {
            return createPortal(children, bindTo);
        }

        return null;
    };

    const openPortal = () => {
        setIsOpen(true);
    };

    const closePortal = () => {
        setIsOpen(false);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain -- Legacy code: do not use as an example.
        onClose && onClose();
    };

    /**
     * Wait for portal node to mount before firing callback
     */
    useIsomorphicLayoutEffect(() => {
        if (isPortalReadyAndOpen) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain -- Legacy code: do not use as an example.
            onOpen && onOpen();
        }
    }, [isPortalReadyAndOpen]);

    return {
        isOpen,
        openPortal,
        closePortal,
        Portal: PortalWrapper,
    };
};
